import { render, staticRenderFns } from "./OrderRetailCustomers.vue?vue&type=template&id=68dc0a0c&scoped=true&"
import script from "./OrderRetailCustomers.vue?vue&type=script&lang=js&"
export * from "./OrderRetailCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc0a0c",
  null
  
)

export default component.exports